module.exports = __webpack_public_path__ + "images/emails/page-t-white-8ce54f66.gif";